import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, LineChart, Line } from 'recharts';
import api from '../services/api';

const s = {
  title: { fontSize:22, fontWeight:600, color:'#f1f5f9', marginBottom:6 },
  sub:   { fontSize:13, color:'#64748b', marginBottom:24 },
  filter:{ display:'flex', gap:12, marginBottom:24, flexWrap:'wrap', alignItems:'center' },
  sel:   { background:'#1e293b', border:'1px solid #334155', color:'#f1f5f9',
           borderRadius:8, padding:'8px 12px', fontSize:13 },
  grid:  { display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 },
  card:  { background:'#1e293b', border:'1px solid #334155', borderRadius:12, padding:20 },
  cardTit:{ fontSize:13, fontWeight:600, color:'#94a3b8', marginBottom:16,
            textTransform:'uppercase', letterSpacing:'.5px' },
  table: { width:'100%', borderCollapse:'collapse' },
  th:    { fontSize:11, color:'#475569', textAlign:'left', padding:'6px 8px',
           borderBottom:'1px solid #1e293b', textTransform:'uppercase' },
  td:    { fontSize:13, color:'#cbd5e1', padding:'8px', borderBottom:'1px solid #1e293b' },
};

const TT = { contentStyle:{background:'#1e293b',border:'1px solid #334155',color:'#f1f5f9'} };

export default function Produtividade() {
  const [dias, setDias] = useState('7');
  const [atId, setAtId] = useState('');
  const [atendentes, setAtendentes] = useState([]);
  const [dados, setDados] = useState([]);
  const [ranking, setRanking] = useState([]);

  useEffect(() => { api.get('/atendentes').then(r => setAtendentes(r.data)); }, []);

  useEffect(() => {
    const params = new URLSearchParams({ dias, ...(atId ? { atendente_id: atId } : {}) });
    api.get(`/dashboard/produtividade?${params}`).then(r => setDados(r.data));
    api.get(`/dashboard/ranking?periodo=${dias === '1' ? 'hoje' : dias+'d'}`).then(r => setRanking(r.data));
  }, [dias, atId]);

  return (
    <div>
      <div style={s.title}>Produtividade</div>
      <div style={s.sub}>Evolução histórica por atendente</div>
      <div style={s.filter}>
        <select style={s.sel} value={dias} onChange={e => setDias(e.target.value)}>
          <option value="1">Hoje</option>
          <option value="7">7 dias</option>
          <option value="30">30 dias</option>
        </select>
        <select style={s.sel} value={atId} onChange={e => setAtId(e.target.value)}>
          <option value="">Todos os atendentes</option>
          {atendentes.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
        </select>
      </div>
      <div style={s.grid}>
        <div style={s.card}>
          <div style={s.cardTit}>Conversas por dia</div>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={dados}>
              <XAxis dataKey="data" tick={{fontSize:11,fill:'#475569'}} />
              <YAxis tick={{fontSize:11,fill:'#475569'}} />
              <Tooltip {...TT} />
              <Bar dataKey="conversas" fill="#0ea5e9" name="Conversas" />
              <Bar dataKey="convertidos" fill="#22c55e" name="Convertidos" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div style={s.card}>
          <div style={s.cardTit}>Mensagens enviadas vs recebidas</div>
          <ResponsiveContainer width="100%" height={220}>
            <LineChart data={dados}>
              <XAxis dataKey="data" tick={{fontSize:11,fill:'#475569'}} />
              <YAxis tick={{fontSize:11,fill:'#475569'}} />
              <Tooltip {...TT} />
              <Legend wrapperStyle={{fontSize:12,color:'#94a3b8'}} />
              <Line type="monotone" dataKey="enviadas"  stroke="#0ea5e9" dot={false} name="Enviadas" />
              <Line type="monotone" dataKey="recebidas" stroke="#f59e0b" dot={false} name="Recebidas" />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <div style={{ ...s.card, gridColumn:'1/-1' }}>
          <div style={s.cardTit}>Ranking do período</div>
          <table style={s.table}>
            <thead><tr>
              {['#','Atendente','Conversas','Enviadas','Convertidos','Taxa conv.','TMA'].map(h => (
                <th key={h} style={s.th}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {ranking.map((r, i) => (
                <tr key={r.id}>
                  <td style={{ ...s.td, color:'#475569' }}>#{i+1}</td>
                  <td style={{ ...s.td, fontWeight:600, color:'#f1f5f9' }}>{r.name}</td>
                  <td style={s.td}>{r.conversas}</td>
                  <td style={s.td}>{r.enviadas}</td>
                  <td style={s.td}>{r.convertidos}</td>
                  <td style={s.td}>{r.taxa_conversao}%</td>
                  <td style={s.td}>{Math.round((r.tma_medio||0)/60)}min</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
